<!-- <div *ngIf="school; else loading" class="app"> -->
<div class="app">
  <div class="images">
    <img
      src="../../assets/images/Summertime Sadness.png"
      class="image-sadness"
    />
    <img src="../../assets/images/Stairs 2.png" class="image-stairs" />
    <img src="../../assets/images/Soft Star.png" class="image-star" />
  </div>
  <a class="advertisement" href="https://inforida.com/" target="_blank">
    <h3>Powered by</h3>
    <div class="logo">
      <img src="../../assets/images/inforida-logo.svg" />
    </div>
  </a>
  <app-notifications
    [message]="school?.bannerMessage"
    [messageLink]="school?.bannerButtonLink"
    [linkText]="school?.bannerButtonText"
    [isAdmission]="school?.quickActions?.admission"
  ></app-notifications>

  <app-header
    *ngIf="school._id"
    [schoolName]="school?.name"
    [schoolLogo]="school?.logo"
    [school]="school"
  ></app-header>

  <app-about *ngIf="school._id" [school]="school"></app-about>
  <app-details *ngIf="school._id" [school]="school"></app-details>
  <div *ngIf="school._id">
    <app-director-desk [school]="school" *ngIf="school._id"></app-director-desk>
  </div>
  <app-about-us *ngIf="school._id" [school]="school"></app-about-us>
  <app-infra-details *ngIf="school._id" [school]="school"></app-infra-details>
  <app-alumni
    [school]="school"
    *ngIf="school?.hallOfFame?.length > 0"
  ></app-alumni>
  <app-toppers
    [school]="school"
    *ngIf="school?.toppers?.length > 0"
  ></app-toppers>
  <app-staff *ngIf="school._id" [school]="school"></app-staff>
  <app-facilities *ngIf="school._id" [school]="school"></app-facilities>
  <app-sports *ngIf="school._id" [school]="school"></app-sports>
  <app-job-blogs *ngIf="school._id"></app-job-blogs>
  <app-testimonials
    [testimonials]="school?.testimonials"
    [textColor]="school?.theme?.secondaryTextColor"
    [backgroundColor]="school?.theme?.secondaryColor"
    *ngIf="school?.testimonials?.length > 0"
  ></app-testimonials>
  <app-disclosure
    *ngIf="school._id"
    [disclosure]="school?.documentList"
    [slug]="school?.slug"
  ></app-disclosure>

  <app-footer *ngIf="school._id" [school]="school"></app-footer>
</div>

<ng-template #loading>
  <div class="loading-container">
    <div class="spinner"></div>
    <p>Loading school data...</p>
  </div>
</ng-template>
